var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-buttons"},_vm._l((_vm.buttons),function(button){return _c('IconButton',{key:button.label,staticClass:"footer-button",attrs:{"icon":button.icon,"label":button.label,"colour":button.colour,"variant":"small"},on:{"onClick":button.onClick}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }